import { useMutation } from '@tanstack/react-query';
import { EventsAPI } from '@newo/api/gateway';
import type { IEventConnectorData } from '@newo/api/gateway';
import axios from '@/utils/api/axiosInstance';

const eventsAPI = new EventsAPI(axios);

// SEND a connector event
export const useSendConnectorEventMutation = () => {
    return useMutation({
        mutationFn: async (data: IEventConnectorData) =>
            eventsAPI.sendConnectorEvent(data)
    });
};
